"use client";

import { useEffect, useState } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
type Stat = {
  label: string;
  value: number;
  suffix: string;
  prefix: string;
  display: string;
  qualifier: string;
  decimals: number;
};
const stats: Stat[] = [{
  label: "ACTIVE PARTNERSHIPS",
  value: 4,
  suffix: "+",
  prefix: "",
  display: "",
  qualifier: "Elite manufacturers represented",
  decimals: 0
}, {
  label: "INDUSTRIES SERVED",
  value: 4,
  suffix: "",
  prefix: "",
  display: "10+",
  qualifier: "Automotive, Metal Fabrication, Safety, Marine, and more!",
  decimals: 0
}, {
  label: "INDUSTRY EXPERIENCE",
  value: 40,
  suffix: "+",
  prefix: "",
  display: "",
  qualifier: "Years Experience",
  decimals: 0
}, {
  label: "CLIENT RETENTION",
  value: 99.2,
  suffix: "%",
  prefix: "",
  display: "",
  qualifier: "Long-term industrial trust",
  decimals: 1
}];
function CountUp({
  target,
  decimals,
  prefix,
  suffix,
  display,
  start,
  index
}: {
  target: number;
  decimals: number;
  prefix: string;
  suffix: string;
  display: string;
  start: boolean;
  index: number;
}) {
  const [value, setValue] = useState(0);
  const [settled, setSettled] = useState(false);
  useEffect(() => {
    if (!start) return;
    if (display) {
      setSettled(true);
      return;
    }
    const duration = 1800;
    const startTime = performance.now() + index * 80;
    let raf = 0;
    const tick = (now: number) => {
      const elapsed = now - startTime;
      if (elapsed < 0) {
        raf = requestAnimationFrame(tick);
        return;
      }
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 4);
      setValue(target * eased);
      if (progress < 1) {
        raf = requestAnimationFrame(tick);
      } else {
        setValue(target);
        setSettled(true);
      }
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [start, target, decimals, display, index]);
  const formatted = display ? display : `${prefix}${value.toFixed(decimals)}${suffix}`;
  return <span className="font-default font-bold text-foreground leading-none tracking-tight transition-colors duration-[260ms]" style={{
    fontSize: "clamp(2.5rem, 3vw + 1rem, 4rem)",
    color: settled ? "var(--foreground)" : "var(--accent)"
  }}>
      {formatted}
    </span>;
}
export default function Reach() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    once: true,
    threshold: 0.25
  });
  return <section data-section-id="15822" id="strategic-reach" className="bg-background text-foreground py-20 md:py-28 px-6 md:px-10 lg:px-16">
      <div ref={ref} className="mx-auto max-w-[1280px]">
        {}
        <div className="flex justify-center mb-6">
          <div className="h-px w-16 transition-all duration-700" style={{
          backgroundColor: "var(--accent)",
          opacity: isVisible ? 1 : 0
        }} />
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-y-12 md:gap-y-0">
          {stats.map((stat, i) => <div data-index={i} key={stat.label} className={["relative px-6 md:px-8 flex flex-col items-start", i > 0 ? "md:border-l md:border-border" : "", i >= 2 ? "border-t border-border pt-12 md:border-t-0 md:pt-0" : ""].join(" ")} style={{
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? "translateY(0)" : "translateY(16px)",
          transition: `opacity 700ms cubic-bezier(0.16, 1, 0.3, 1) ${i * 80}ms, transform 700ms cubic-bezier(0.16, 1, 0.3, 1) ${i * 80}ms`
        }}>
              <span className="font-mono text-muted-foreground mb-5 block" style={{
            fontSize: "0.75rem",
            letterSpacing: "0.15em",
            lineHeight: 1.3
          }}>
                {stat.label}
              </span>

              <div className="mb-4">
                <CountUp target={stat.value} decimals={stat.decimals} prefix={stat.prefix} suffix={stat.suffix} display={stat.display} start={isVisible} index={i} />
              </div>

              <p className="font-default text-foreground/80" style={{
            fontSize: "0.9375rem",
            lineHeight: 1.5,
            fontWeight: 400
          }}>
                {stat.qualifier}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}